import React, { useEffect, useRef, useState } from "react";
import "../ShareView.css"
import { useSelector } from "react-redux";
import axios from "axios";
import { Button } from "primereact/button";
import MenuPage from "./MenuPage";


const ShareView = () => {
	const { peerhost, peerport, num } = useSelector((state) => state.AuthReducer);

	const [peer, setPeer] = useState(null);
	const [rows, setRows] = useState([]);
	const [share, setShare] = useState(false);

	const localStreamRef = useRef(null);
	const callsRef = useRef([]);
	const peerRef = useRef(null);
	const videoRef = useRef(null);

	const ONE_DAY_MS = 24 * 60 * 60 * 1000;

	function isOneDayPassed(timestamp) {
		return Date.now() - timestamp >= ONE_DAY_MS;
	}


	const shareviewList = async () => {
		const url = `/api/member/shareview_list.json`;
		const { data } = await axios.get(url);

		let arr = [];
		if (data.result.length > 0) {
			for (const item of data.result) {
				if (isOneDayPassed(item.timestamp)) {
					const url1 = `/api/member/shareview_delete.json?cid=${item.cid}`;
					await axios.delete(url1);
				}
				else {
					if (num !== item.cid) {
						arr.push({ 'cid': item.cid })
					}
				}
			}
			setRows(arr);
		}
	}


	useEffect(() => {
		shareviewList();
		return () => {
			// 1. video 정리
			if (videoRef.current?.srcObject) {
				videoRef.current.srcObject
					.getTracks()
					.forEach(track => track.stop());
				videoRef.current.srcObject = null;
			}

			// 2. peer 종료
			if (peerRef.current && !peerRef.current.destroyed) {
				peerRef.current.destroy();
				peerRef.current = null;
			}
		};
	}, []);



	useEffect(() => {
		if (num !== 0) {
			initializePeer(num);
		}
		return () => {
			if (peerRef.current) {
				console.log("Destroying peer:", peerRef.current.id);
				peerRef.current.destroy();
				peerRef.current = null;
			}
		};
	}, [num]);


	function initializePeer(customId) {
		let peer;

		if (peer && !peer.disconnected && !peer.destroyed) {
			return;
		}

		if (peerRef.current) {
			peerRef.current.destroy();
			peerRef.current = null;
		}

		// ID가 입력되면 해당 ID로, 없으면 랜덤으로 생성 Peer 생성 옵션
		let options = {
			host: peerhost,
			port: peerport,
			path: '/peerjs',
			debug: 2,
			secure: true
		};

		if (customId) {
			peer = new window.Peer(customId, options);
		} else {
			peer = new window.Peer(options); // 랜덤 ID
		}

		peer.on('open', (id) => {

		});

		peer.on('call', (call) => {
			callsRef.current.push(call);

			if (localStreamRef.current) {
				call.answer(localStreamRef.current);
			} else {
				call.answer();
			}
		});

		peer.on('connection', (conn) => {
			console.log("Incoming data connection from:", conn.peer);

			conn.on('open', () => {
				console.log("Data connection established with:", conn.peer);
				conn.send({ type: 'chat', sender: 'System', message: '파일 전송 가능' });
			});

			conn.on('data', (data) => {
				// handleIncomingData(data);
			});

			conn.on('close', () => {
				console.log("Data connection closed:", conn.peer);
			});
		});


		peer.on('error', (err) => {
			console.error('PeerJS Error:', err);

			if (err.type === 'unavailable-id') {
				// alert("이미 사용 중인 ID입니다. 다른 ID를 입력해주세요.");
				peer = null;
			} else {
				alert('연결 에러 발생: ' + err.type);
			}
		});

		peerRef.current = peer;
		setPeer(peer);
	}


	async function startScreenShare() {
		try {
			const videoElement = document.getElementById('screen-preview');

			// 화면 공유 스트림 요청 (오디오 포함)
			const localStream = await navigator.mediaDevices.getDisplayMedia({
				video: { 
					cursor: "always", 
					frameRate: 15,
					width: { max: 1280 },
					height: { max: 720 } 
				},
				audio: false // 시스템 오디오 공유 활성화
			});


			localStreamRef.current = localStream;

			callsRef.current.forEach(call => {
				const sender = call.peerConnection
					.getSenders()
					.find(s => s.track && s.track.kind === "video");

				if (sender) {
					sender.replaceTrack(localStream.getVideoTracks()[0]);
				}
			});

			videoElement.srcObject = localStream;
			videoElement.muted = true; // 내 화면은 소리 끔

			localStream.getVideoTracks()[0].onended = () => {
				console.log('화면 공유가 중단되었습니다.');
				videoElement.srcObject = null;
				setShare(false);
			};

			setShare(true);
		} catch (err) {
			console.error("화면 공유 시작 실패:", err);
			setShare(false);
		}
	}

	function stopScreenShare() {
		if (!localStreamRef.current) return;

		// 모든 트랙 중지 (이게 핵심)
		localStreamRef.current.getTracks().forEach(track => track.stop());

		// video 화면 제거
		const videoElement = document.getElementById('screen-preview');
		if (videoElement) {
			videoElement.srcObject = null;
		}

		callsRef.current.forEach(call => {
			const sender = call.peerConnection
				.getSenders()
				.find(s => s.track && s.track.kind === "video");

			if (sender) {
				sender.replaceTrack(null);
			}
		});

		localStreamRef.current = null;
		setShare(false);
	}


	function connectToPeer(friendId) {
		console.log(`Connecting to ${friendId}...`);

		const videoContainer = document.getElementById('video-container');
		const exitBtn = document.getElementById('exit-fullscreen-btn');
		if (!document.fullscreenElement) {
			videoContainer.requestFullscreen().then(() => {
				exitBtn.style.display = 'block';
			}).catch(err => {
				console.warn("Auto-fullscreen failed:", err);
			});
		}

		const canvas = document.createElement('canvas');
		canvas.width = 1;
		canvas.height = 1;
		const dummyStream = canvas.captureStream();

		const call = peer.call(friendId, dummyStream);
		console.log(call);

		if (!call) {
			console.error("Failed to initiate call. 'call' object is undefined.");
			alert("연결 시도에 실패했습니다. PeerJS 상태를 확인해주세요.");
			return;
		}

		call.on('stream', (remoteStream) => {
			if (!videoRef.current) return;   // ⭐ 방어 코드

			videoRef.current.srcObject = remoteStream;
			videoRef.current.muted = false;

			videoRef.current.play().catch(e =>
				console.error("Autoplay failed:", e)
			);
		});


		call.on('close', () => {
			if (videoRef.current) {
				videoRef.current.srcObject = null;
			}

			if (document.fullscreenElement) {
				document.exitFullscreen();
			}
		});


		call.on('error', (err) => {
			console.error("Call error:", err);
			alert("연결 중 오류가 발생했습니다.");
		});

		const conn = peer.connect(friendId);
		conn.on('open', () => {
			console.log("Connected to Host Data Channel");
		});

		conn.on('data', (data) => {
			// handleIncomingData(data);
		});

		conn.on('error', (err) => {
			console.error("Data connection error:", err);
		});
	}

	// 3. Utils: 전체화면 토글
	function toggleFullScreen() {
		const videoContainer = document.getElementById('video-container');
		const exitBtn = document.getElementById('exit-fullscreen-btn');

		if (!document.fullscreenElement) {
			videoContainer.requestFullscreen().then(() => {
				exitBtn.style.display = 'block'; // 전체화면 때 버튼 보이기
			}).catch(err => {
				alert(`전체화면 모드 전환 실패: ${err.message}`);
			});
		} else {
			document.exitFullscreen().then(() => {
				exitBtn.style.display = 'none'; // 전체화면 종료 시 버튼 숨기기
			});
		}
	}

	// 전체화면 상태 감지 (Esc키로 나갔을 때도 버튼 숨기기 위함)
	document.addEventListener('fullscreenchange', () => {
		const exitBtn = document.getElementById('exit-fullscreen-btn');
		if (!document.fullscreenElement) {
			exitBtn.style.display = 'none';
		} else {
			exitBtn.style.display = 'block';
		}
	});


	return (
		<div className="card flex justify-content-center"
			style={{
				position: 'sticky',
				top: 0,
				zIndex: 1000,
				background: '#f0f2f5',
				paddingTop: '5px',
				paddingBottom: '2px',
			}}
		>
			<div>
				<MenuPage />

				<hr />
			</div>

			<div className="app">
				<div className="sidebar">
					<div className="control-panel">
						{share === false && <Button label={`${num} 화면공유`} onClick={startScreenShare} style={{ width: '100%' }} severity="success" size="small" />}
						{share === true && <Button label={`${num} 공유중지`} onClick={stopScreenShare} style={{ width: '100%' }} severity="warning" size="small" />}
					</div>

					<div className="participant-section">
						{rows.length === 0 ? (
							<div>현재 접속자가 없습니다.</div>
						) : (
							rows.map((row) => (
								<div key={row.cid} style={{ marginTop: '2px', marginBottom: '2px' }}>
									<Button label={`${row.cid} 연결`} onClick={() => connectToPeer(row.cid)} style={{ width: '100%' }} severity='secondary' size="small"></Button>
								</div>
							))
						)}
					</div>
				</div>


				<div className="main-content">
					<div id="video-container">
						<video ref={videoRef} id="screen-preview" autoPlay playsInline></video>

						<button id="exit-fullscreen-btn" className="button" onClick={toggleFullScreen} style={{ display: "none" }}>
							❌ Exit Fullscreen
						</button>
					</div>

					<button className="fullscreen-btn button" onClick={toggleFullScreen}>
						⛶ Fullscreen
					</button>
				</div>
			</div>

			<footer>
				<div className="container">
					<div className="row">
						<p className="copyright text-muted">2016 &copy; ihongss.com</p>
					</div>
				</div>
			</footer>
		</div>
	);
};

export default ShareView;
